import { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Form, Button } from 'react-bootstrap';
import Message from '../../components/Message';
import Loader from '../../components/Loader';
import FormContainer from '../../components/FormContainer';
import { toast } from 'react-toastify';
import {
  useGetSupplierDetailsQuery,
  useUpdateSupplierMutation,
} from '../../slices/suppliersApiSlice';

const SupplierStaffEditScreen = () => {
  const { id: supplierId } = useParams();

  const [name, setName] = useState('');
  const [telephone, setTelephone] = useState('');
  const [company, setCompany] = useState('');
  const [serialNumber, setSerialNumber] = useState('');
  const [address, setAddress] = useState('');

  const {
    data: supplier,
    isLoading,
    refetch,
    error,
  } = useGetSupplierDetailsQuery(supplierId);

  const [updateSupplier, { isLoading: loadingUpdate }] = useUpdateSupplierMutation();

  const navigate = useNavigate();

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      await updateSupplier({
        supplierId,
        name,
        telephone,
        company,
        serialNumber,
        address,
      }).unwrap();
      toast.success('Supplier updated');
      refetch();
      navigate('/supplierlist'); // Redirect to the supplier list
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  useEffect(() => {
    if (supplier) {
      setName(supplier.name);
      setTelephone(supplier.telephone);
      setCompany(supplier.company);
      setSerialNumber(supplier.serialNumber);
      setAddress(supplier.address);
    }
  }, [supplier]);

  return (
    <>
      <Link to="/supplierlist" className="btn btn-light my-3">
        Go Back
      </Link>
      <FormContainer>
        <h1>Edit Supplier</h1>
        {loadingUpdate && <Loader />}
        {isLoading ? (
          <Loader />
        ) : error ? (
          <Message variant="danger">{error.data.message}</Message>
        ) : (
          <Form onSubmit={submitHandler}>
            <Form.Group controlId="name">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              ></Form.Control>
            </Form.Group>

            <Form.Group controlId="telephone">
              <Form.Label>Telephone</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter telephone"
                value={telephone}
                onChange={(e) => setTelephone(e.target.value)}
              ></Form.Control>
            </Form.Group>

            <Form.Group controlId="company">
              <Form.Label>Company</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter company"
                value={company}
                onChange={(e) => setCompany(e.target.value)}
              ></Form.Control>
            </Form.Group>

            <Form.Group controlId="serialNumber">
              <Form.Label>Serial Number</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter serial number"
                value={serialNumber}
                onChange={(e) => setSerialNumber(e.target.value)}
              ></Form.Control>
            </Form.Group>

            <Form.Group controlId="address">
              <Form.Label>Address</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter address"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              ></Form.Control>
            </Form.Group>

            <Button
              type="submit"
              variant="primary"
              style={{ marginTop: '1rem' }}
            >
              Update
            </Button>
          </Form>
        )}
      </FormContainer>
    </>
  );
};

export default SupplierStaffEditScreen;